export default () => {
  return localStorage.getItem('user') != null
}
